import { Loader } from 'src/domains/layouts/webview/components/loader/Loader';

import styled from '@emotion/styled';

import { withConfig } from 'src/withConfig';

import { css, SerializedStyles } from '@emotion/react';

import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';



export const RaceHeaderWrapper = styled('div', { label: 'RaceHeaderWrapper' })`

    padding: 0 8px;

    position: relative;

`;



export const RaceHeaderDetails = withConfig(theme => styled('header', { label: 'RaceHeaderDetails' })`

    color: ${theme.star.quickPick.txtColor};

    padding: 6px 0 8px;

`);



export const RaceHeaderDetailsName = withConfig(theme => styled('h4', { label: 'RaceHeaderDetailsName' })`

    font-size: ${theme.star.fontSize.regular};

    font-weight: ${theme.star.fontWeight.bold};

    line-height: 1.5;

    margin: 0;

    @media ${theme.star.mediaQuery.tablet} {

        font-size: ${theme.star.fontSize.xMedium};

        line-height: 1.4;

    }

`);



export const RaceHeaderDetailsDistance = styled('div', { label: 'RaceHeaderDetailsDistance' })`

    display: flex;

    flex-flow: row wrap;

    margin-top: 3px;

`;



export const RaceHeaderListMeta = withConfig(theme => styled('ul', { label: 'RaceHeaderListMeta' })`

    font-size: ${theme.star.fontSize.small};

    font-weight: ${theme.star.fontWeight.regular};

    line-height: 1.3334;

    margin-right: 8px;

`);



export const RaceHeaderListItemMeta = styled('li', { label: 'RaceHeaderListItemMeta' })`

    display: inline-block;

    margin: 0 5px 0 0;

    &:last-of-type {

        margin-right: 0;

    }

`;



export const RaceHeaderListItemSeparatorMeta = styled(RaceHeaderListItemMeta, { label: 'RaceHeaderListItemSeparatorMeta' })`

    position: relative;

    width: 1px;

    &:last-of-type {

        display: none;

    }

    &::after {

        background-color: currentcolor;

        bottom: 0;

        content: '';

        height: 100%;

        left: 0;

        margin: auto;

        position: absolute;

        right: 0;

        top: 0;

        width: 1px;

    }

`;



export const RaceHeaderListEwTerms = withConfig(theme => styled('ul', { label: 'RaceHeaderListEwTerms' })`

    font-size: ${theme.star.fontSize.small};

    font-weight: ${theme.star.fontWeight.regular};

    line-height: 1.3334;

`);



export const RaceHeaderListItem = withConfig(theme => styled('li', { label: 'RaceHeaderListItem' })`

    display: inline-block;

    font-weight: ${theme.star.fontWeight.medium};

    margin-right: 5px;

`);



interface QuickPickPropsType {

    variant: DefaultComponentVariantType | null;

}



const setQuickPickStyle = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            background: ${theme.star.quickPick.bgColorSeptenary};

            padding: ${theme.star.padding.medium};

        `;

    }

    return css`

        background: ${theme.star.quickPick.bgColorOctonary};

    `;

};



export const QuickPickStyle = withConfig(theme => styled('section', { label: 'QuickPickStyle' })<QuickPickPropsType>`

    color: ${theme.star.quickPick.txtColorQuaternary};

    ${({ variant }): SerializedStyles=> setQuickPickStyle(variant, theme)};

`);



export const QuickPickInfo = withConfig(theme => styled('div', { label: 'QuickPickInfo' })`

    color: ${theme.star.quickPick.txtColorQuinary};

    font-size: ${theme.star.fontSize.xRegular};

    padding: 10px 5px 15px;

    position: relative;

    text-align: center;

`);



const setQuickPickColumnTitleWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            padding: ${theme.star.padding.small};

        `;

    }

    return css``;

};



export const QuickPickColumnTitleWrapper = withConfig(theme => styled('div', { label: 'QuickPickColumnTitleWrapper' })<QuickPickPropsType>`

    ${({ variant }): SerializedStyles=> setQuickPickColumnTitleWrapper(variant, theme)};

`);



const setQuickPickColumnTitle = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            border-radius: ${theme.star.radius.small};

        `;

    }

    return css`

        border-bottom: 1px solid ${theme.star.quickPick.borderColor};

        border-right: 1px solid ${theme.star.quickPick.borderColor};

        margin-left: -1px;

    `;

};



interface QuickPickColumnPropsType {

    variant: DefaultComponentVariantType | null;

    isSelected: boolean;

}



export const QuickPickColumnTitle = withConfig(theme => styled('span', { label: 'QuickPickColumnTitle' })<QuickPickColumnPropsType>`

    ${({ variant }): SerializedStyles=> setQuickPickColumnTitle(variant, theme)};

    color: ${theme.star.quickPick.txtColor};

    height: 50px;

    line-height: 1.4;

    overflow: hidden;

    padding-top: 8px;

    position: relative;

    text-overflow: ellipsis;

    transition: 300ms all ease-in;

    white-space: nowrap;

    ${({ isSelected }): SerializedStyles => {

        if (isSelected === true) {

            return css`

                color: ${theme.star.quickPick.txtColorTertiary};

                background-color: ${theme.star.quickPick.bgColorSecondary};

                z-index: ${theme.star.zIndexGlobal.above};

            `;

        }

        return css``;

    }}

`);



const setQuickPickColumnStyle = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            gap: ${theme.star.gap.small};

            .quick-pick__selection {

                padding: ${theme.star.padding.small};

            }

            .quick-pick__selection:hover::after {

                border-radius: ${theme.star.radius.small};

            }

        `;

    }

    return css`

        .quick-pick__selection {

            border-color: ${theme.star.quickPick.borderColor};

            border-style: solid;

            border-width: 0 1px 1px 1px;

        }

    `;

};



export const QuickPickColumnStyle = withConfig(theme => styled('div', { label: 'QuickPickColumnStyle' })<QuickPickColumnPropsType>`

    ${({ variant }): SerializedStyles=> setQuickPickColumnStyle(variant, theme)};

    display: flex;

    flex-flow: column nowrap;

    flex: 0 0 69px;

    justify-content: flex-start;

    position: relative;

    text-align: center;

    width: 69px;

    .quick-pick__selection {

        display: flex;

        flex-direction: row;

        font-size: ${theme.star.fontSize.xRegular};

        font-weight: ${theme.star.fontWeight.bold};

        height: 50px;

        justify-content: center;

        margin-left: -1px;

        min-height: 50px;

        opacity: ${({ isSelected }): string => isSelected ? '1' : '0.4'};

    }



    .quick-pick__selection:hover {

        z-index: ${theme.star.zIndexGlobal.above};

    }



    .quick-pick__selection:hover::after {

        background-color: ${theme.star.quickPick.bgColorTertiary};

    }

`);



const setQuickPickContent = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            border-radius: ${theme.star.radius.medium};

            padding: ${theme.star.padding.small} ${theme.star.padding.small} ${theme.star.padding.large} ${theme.star.padding.small};

        `;

    }

    return css`

        border: 1px solid ${theme.star.quickPick.borderColor};

        padding-bottom: ${theme.star.padding.large};

    `;

};



export const QuickPickContent = withConfig(theme => styled('div', { label: 'QuickPickContent' })<QuickPickPropsType>`

    ${({ variant }): SerializedStyles=> setQuickPickContent(variant, theme)};

    background-color: ${theme.star.quickPick.bgColor};

    display: flex;

    flex-flow: row nowrap;

`);



const setQuickPickNameStyle = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            flex-flow: column nowrap;

            gap: ${theme.star.gap.small};

        `;

    }

    return css`

        li {

            box-shadow: inset 0 -1px 0 0 ${theme.star.quickPick.borderColor};

        }

    `;

};



export const QuickPickNameStyle = withConfig(theme => styled('ul', { label: 'QuickPickNameStyle' })<QuickPickPropsType>`

    ${({ variant }): SerializedStyles=> setQuickPickNameStyle(variant, theme)};

    flex: 0 0 220px;

    max-width: 220px;

    li {

        align-items: stretch;

        display: flex;

        flex-flow: row nowrap;

        font-size: ${theme.star.fontSize.xRegular};

        height: 50px;

        justify-content: space-between;

    }



    .hovered {

        background-color: ${theme.star.quickPick.bgColorQuinary};

        color: ${theme.star.quickPick.txtColorSenary};

    }

    .quick-pick__name--nr > * {

        opacity: 0.3;

    }

`);



export const QuickPickNameTitle = withConfig(theme => styled('li', { label: 'QuickPickNameTitle' })`

    background-color: ${theme.star.quickPick.bgColor};

    border-bottom: 0;

    color: ${theme.star.quickPick.txtColor};

    line-height: 1.5;

    position: relative;

`);



export const QuickPickNamePlace = withConfig(theme => styled('span', { label: 'QuickPickNamePlace' })<QuickPickPropsType>`

    align-items: center;

    border-right: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none': `1px solid ${theme.star.quickPick.borderColor}`};

    color: ${theme.star.quickPick.txtColor};

    display: flex;

    flex: 0 0 30px;

    flex: column nowrap;

    font-size: ${theme.star.quickPick.typography.fontSizePrimary};

    line-height: ${theme.star.quickPick.typography.lineHeightPrimary};

    font-weight: ${theme.star.quickPick.typography.fontWeightPrimary};

    justify-content: center;

    padding: 8px 0;

    text-align: center;

`);



export const QuickPickNameSilk = withConfig(theme => styled('div', { label: 'QuickPickNameSilk' })<QuickPickPropsType>`

    align-items: center;

    border-right: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none': `1px solid ${theme.star.quickPick.borderColor}`};

    display: flex;

    flex-flow: column nowrap;

    font-size: ${theme.star.quickPick.typography.fontSizePrimary};

    line-height: ${theme.star.quickPick.typography.lineHeightPrimary};

    font-weight: ${theme.star.quickPick.typography.fontWeightPrimary};

    justify-content: center;

    min-width: 40px;

    padding: 8px 0;

    text-align: center;

    svg, img {

        display: block;

        height: auto;

        margin: auto;

        max-width: 25px;

    }

`);



export const QuickPickSilkHrWrapper = withConfig(theme => styled('div', { label: 'QuickPickSilkHrWrapper' })<QuickPickPropsType>`

    border-right: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none': `1px solid ${theme.star.quickPick.borderColor}`};

    display: flex;

    flex-flow: column nowrap;

    justify-content: center;

    min-width: 40px;

    padding: 8px 0;

    text-align: center;

    align-items: center;

    svg {

        max-width: 25px;

    }

`);



export const QuickPickSilk = styled(LazyImageSilk, { label: 'QuickPickSilk' })`

    width: 32px;

`;



export const QuickPickNameRunner = withConfig(theme => styled('div', { label: 'QuickPickNameRunner' })<QuickPickPropsType>`

    border-right: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none': `1px solid ${theme.star.quickPick.borderColor}`};

    color: ${theme.star.quickPick.txtColor};

    display: flex;

    flex-flow: column nowrap;

    flex: 1 1 auto;

    font-size: ${theme.star.fontSize.small};

    font-weight: ${theme.star.fontWeight.medium};

    justify-content: center;

    line-height: 1.28;

    min-width: 29px;

    overflow: hidden;

    padding: 8px 10px;

    text-align: left;

    text-overflow: ellipsis;

    white-space: nowrap;

`);



export const QuickPickNameRunnerTitle = withConfig(theme => styled(QuickPickNameRunner, { label: 'QuickPickNameRunnerTitle' })`

    font-size: ${theme.star.quickPick.typography.fontSizePrimary};

    line-height: ${theme.star.quickPick.typography.lineHeightPrimary};

    font-weight: ${theme.star.quickPick.typography.fontWeightPrimary};

    padding: 8px;

`);



export const LoaderWrapperQuickPick = styled(Loader, { label: 'LoaderWrapperQuickPick' })`

    justify-content: center;

`;



export const QuickPickTableWrapper = withConfig(theme => styled('div', { label: 'QuickPickTableWrapper' })`

    align-content: space-between;

    align-items: stretch;

    display: flex;

    flex-flow: row nowrap;

    flex: 1 1 auto;

    font-size: ${theme.star.fontSize.xRegular};

    overflow: auto;

`);



interface QuickPickHeaderProps {

    variant: DefaultComponentVariantType | null;

}



const setQuickPickHeaderBorders = ({ variant }: QuickPickHeaderProps, theme: EmotionTheme): SerializedStyles => {

    if (variant !== DefaultComponentVariantType.SECONDARY) {

        return css`

            border-left: 1px solid ${theme.star.quickPick.borderColor};

            border-right: 1px solid ${theme.star.quickPick.borderColor};

        `

    }

    return css``;

}



export const QuickPickHeader = withConfig(theme => styled('div', { label: 'QuickPickHeader' })<QuickPickHeaderProps>`

    border-top-width: 0;

    border-bottom-width: 0;

    ${(props): SerializedStyles => setQuickPickHeaderBorders(props, theme)}

    font-size: ${theme.star.fontSize.small};

    line-height: 1.5;

    ul li:empty {

        display: none;

    }

`);

